import React, { Component } from "react"
import SvgIcon from 'src/components/SvgIcon'

import './PageTitle.less'

class PageTitle extends Component {
  
  render() {
    const { title, icon, className, rightRender } = this.props

    return (
      <div className={'c-layout-page-title ' + (className || '')}>
        {icon && (
          <SvgIcon type={icon} size={'md'} />
        )}
        <span>{title || ''}</span>
        {typeof rightRender === 'function' && (
          <div className="page-title-right-content">
            {rightRender()}
          </div>
        )}
      </div>
    )
  }
}

export default PageTitle
